import { useCallback, useEffect, useRef, useState } from "react";

import { TextField } from "@mui/material";

import { useInterval, useShipmentFiltersContext } from "hooks";

interface Props {
  tabType: "regular" | "supplier";
  size?: "small" | "medium";
  sx?: object;
}

export function ShipmentSearchByName(props: Props) {
  const { tabType, size = "medium", sx } = props;
  const { updateShipmentName, filters } = useShipmentFiltersContext(tabType);

  const [searchValue, setSearchValue] = useState<string>(
    filters?.shipmentName ?? "",
  );
  const [lastValueSearched, setLastValueSearched] = useState<string | null>(
    null,
  );
  const prevContextName = useRef<string>(filters?.shipmentName ?? "");

  const search = useCallback(() => {
    if (lastValueSearched !== searchValue) {
      updateShipmentName(searchValue);
      setLastValueSearched(searchValue);
      prevContextName.current = searchValue;
    }
  }, [searchValue, lastValueSearched, updateShipmentName]);

  useEffect(() => {
    const contextName = filters?.shipmentName ?? "";

    if (contextName !== prevContextName.current) {
      prevContextName.current = contextName;
      setSearchValue(contextName);
      setLastValueSearched(contextName);
    }
  }, [filters?.shipmentName]);

  useInterval(search, 1000);

  return (
    <TextField
      onChange={(e) => {
        setSearchValue(e.target.value);
      }}
      label="Shipment Ref/ID"
      value={searchValue}
      size={size}
      sx={{ ...sx }}
    />
  );
}
